import React from 'react'
import RevenueSelectOptions from './RevenueSelectOptions'
import RevenueTable from '../RevenueTable'

const revenueData1 = {
    id: 'table1',
    data: [
        { centerName: 'SAAOL Dehradun', revenue: '₹176,000', refund: '₹0', manager: 'Mr. Manoj' },
        { centerName: 'SAAOL Delhi', revenue: '₹200,000', refund: '₹10,000', manager: 'Mr. Sharma' },
        { centerName: 'SAAOL Delhi', revenue: '₹200,000', refund: '₹10,000', manager: 'Mr. Sharma' },
        { centerName: 'SAAOL Delhi', revenue: '₹200,000', refund: '₹10,000', manager: 'Mr. Sharma' },
        { centerName: 'SAAOL Delhi', revenue: '₹200,000', refund: '₹10,000', manager: 'Mr. Sharma' },
        { centerName: 'SAAOL Delhi', revenue: '₹200,000', refund: '₹10,000', manager: 'Mr. Sharma' },
    ]
};

const revenueData2 = {
    id: 'table2',
    data: [
        { centerName: 'SAAOL Mumbai', revenue: '₹300,000', refund: '₹5,000', manager: 'Mr. Ramesh' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
    ]
};
const revenueData3 = {
    id: 'table3',
    data: [
        { centerName: 'SAAOL Mumbai', revenue: '₹300,000', refund: '₹5,000', manager: 'Mr. Ramesh' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
    ]
};
const revenueData4 = {
    id: 'table4',
    data: [
        { centerName: 'SAAOL Mumbai', revenue: '₹300,000', refund: '₹5,000', manager: 'Mr. Ramesh' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
    ]
};
const revenueData5 = {
    id: 'table5',
    data: [
        { centerName: 'SAAOL Mumbai', revenue: '₹300,000', refund: '₹5,000', manager: 'Mr. Ramesh' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
    ]
};
const revenueData6 = {
    id: 'table6',
    data: [
        { centerName: 'SAAOL Mumbai', revenue: '₹300,000', refund: '₹5,000', manager: 'Mr. Ramesh' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
        { centerName: 'SAAOL Chennai', revenue: '₹150,000', refund: '₹0', manager: 'Mr. Raj' },
    ]
};



const RevenueAccordian = () => {

    return (
        <div className="accordion" id="accordionPanelsStayOpenExample">
            <div className="accordion-item">
                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                        Revenue Overview (Own Rev: ₹ 18500 | Partnership Rev: ₹0 | Franchise Rev: ₹ 0)
                    </button>
                </h2>
                <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                    <div className="accordion-body">
                        <div className='my-3'>
                            <RevenueSelectOptions />
                        </div>
                        <div className="accordion" id="accordionExample">
                            {[
                                { id: 1, name: "Uttarakhand", revenue: "₹473500", refund: "₹0", data: revenueData1 },
                                { id: 2, name: "Karnataka", revenue: "₹272000", refund: "₹0", data: revenueData2 },
                                { id: 3, name: "Maharashtra", revenue: "₹255500", refund: "₹0", data: revenueData3 },
                                { id: 4, name: "New Delhi", revenue: "₹12500", refund: "₹0", data: revenueData4 },
                                { id: 5, name: "Tamil Nadu", revenue: "₹84000", refund: "₹0", data: revenueData5 },
                                { id: 6, name: "West Bengal", revenue: "₹166000", refund: "₹0", data: revenueData6 }
                            ].map(({ id, name, revenue, refund, data }) => (
                                <div className="accordion-item bg_sky" key={id}>
                                    <h2 className="accordion-header" id={`heading_${id}`}>
                                        <button
                                            className="accordion-button collapsed" // Closed by default
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse_${id}`} // Unique target
                                            aria-expanded="false"
                                            aria-controls={`collapse_${id}`}
                                        >
                                            {name} (Rev: {revenue}) (Ref: {refund})
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse_${id}`}
                                        className="accordion-collapse collapse" // Closed by default
                                        aria-labelledby={`heading_${id}`}
                                    >
                                        <div className="accordion-body">
                                            <RevenueTable tableData={data} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default RevenueAccordian


// import React, { useEffect } from "react";
// import $ from "jquery";
// import "datatables.net-dt/js/dataTables.dataTables.js";
// import { useSelector } from "react-redux";

// const DailyReportTable = ({ id, mainHeader, statename }) => {
//     const token = useSelector((state) => state.auth.accessToken);
//     useEffect(() => {
//         const table = $(`#dataTable${id}`).DataTable({
//             processing: true,
//             serverSide: true,
//             ajax: {
//                 url: "https://erp.saaol.com/api/v1/reports/daily", // Replace with your actual API endpoint
//                 type: "POST",
//                 contentType: "application/json",
//                 headers: {
//                     Authorization: `Bearer ${token}`, // <-- Pass token here
//                 },
//                 data: function (d) {
//                     // Modify the request parameters before sending to the server
//                     return JSON.stringify({
//                         page: d.start / d.length + 1,
//                         per_page: d.length,
//                         search: d.search.value,
//                         sort_by: d.columns[d.order[0].column].data,
//                         sort_order: d.order[0].dir,
//                         startDate: "2025-04-01", // Replace with dynamic values if needed
//                         endDate: "2025-05-12",   // Replace with dynamic values if needed
//                         state: statename,
//                     });
//                 },
//                 dataSrc: function (json) {
//                     // Modify the response from the server if necessary
//                     return json.data;
//                 },
//             },
//             columns: mainHeader.map((col) => {
//                 if (col.rowSpan) {
//                     return { data: col.key, title: col.label };
//                 } else if (col.subColumns) {
//                     return col.subColumns.map((subCol) => ({
//                         data: subCol.key,
//                         title: subCol.label,
//                     }));
//                 }
//                 return null;
//             }).flat().filter(Boolean),
//             scrollX: true,
//             autoWidth: false,
//         });

//         return () => {
//             table.destroy();
//         };
//     }, [id, mainHeader]);

//     return (
//         <div className="card basic-data-table cursor-pointer">
//             <div className="card-body p-2 pt-20">
//                 <table
//                     className="table table-sm table-bordered table-hover small custom_table"
//                     id={`dataTable${id}`}
//                     data-page-length={10}
//                 >
//                     <thead>
//                         <tr>
//                             {mainHeader.map((col, idx) =>
//                                 col.rowSpan ? (
//                                     <th key={idx} rowSpan={col.rowSpan}>
//                                         {col.label}
//                                     </th>
//                                 ) : (
//                                     <th key={idx} colSpan={col.colSpan} className="text-center">
//                                         {col.label}
//                                     </th>
//                                 )
//                             )}
//                         </tr>
//                         <tr>
//                             {mainHeader.map((col, idx) =>
//                                 !col.rowSpan && col.subColumns
//                                     ? col.subColumns.map((subCol, sIdx) => (
//                                         <th key={`${idx}-${sIdx}`}>{subCol.label}</th>
//                                     ))
//                                     : null
//                             )}
//                         </tr>
//                     </thead>
//                     <tbody></tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default DailyReportTable;

// import React, { useState, useEffect } from "react";
// import DailyReportTable from "./child/DailyReportTable";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import DailyReportSelectOptions from "./child/DailyReportSelectOptions";

// const mainHeader = [
//     { label: "Sr.no", rowSpan: 2, key: "srNo" },
//     { label: "Center Name", rowSpan: 2, key: "centerName" },
//     { label: "Date", rowSpan: 2, key: "date" },
//     { label: "Status", rowSpan: 2, key: "status" },
//     {
//         label: "Leads", colSpan: 6, subColumns: [
//             { key: "lead_new", label: "New" },
//             { key: "lead_closed", label: "Close" },
//             { key: "lead_followUp", label: "Followups" },
//             { key: "lead_schedule", label: "Schedule" },
//             { key: "lead_transfered", label: "Transfered" },
//             { key: "lead_converted", label: "Converted to opd" },
//         ],
//     },
//     {
//         label: "Patients(OPD)", colSpan: 6, subColumns: [
//             { key: "appointment_scheduled", label: "Scheduled" },
//             { key: "appointment_cancel", label: "Cancel" },
//             { key: "appointment_finished", label: "Finished" },
//             { key: "appointment_transfer", label: "Transfer to center" },
//             { key: "appointment_treatment", label: "Cnvt to treatment" },
//             { key: "appointment_investigation", label: "Cnvt to investigation" },
//         ],
//     },
//     {
//         label: "Patients(SNB,STD)", colSpan: 8, subColumns: [
//             { key: "Patients_machine", label: "Number of machine" },
//             { key: "Patients_running", label: "running patient" },
//             { key: "Patients_added", label: "Patient added today" },
//             { key: "Patients_finish", label: "Patient finish today" },
//             { key: "Patients_netRunning", label: "net running patient" },
//             { key: "Patients_transfer", label: "Patient transfer today" },
//             { key: "Patients_netTreatmentFinish", label: "net treatment finish" },
//             { key: "Patients_CUI", label: "CUI" },
//         ],
//     },
// ];

// const statesList = [
//     { id: 1, name: "Uttarakhand", revenue: "₹473500", refund: "₹0" },
//     { id: 2, name: "Karnataka", revenue: "₹272000", refund: "₹0" },
//     { id: 3, name: "Maharashtra", revenue: "₹255500", refund: "₹0" },
//     { id: 4, name: "New Delhi", revenue: "₹12500", refund: "₹0" },
//     { id: 5, name: "Tamil Nadu", revenue: "₹84000", refund: "₹0" },
//     { id: 6, name: "West Bengal", revenue: "₹166000", refund: "₹0" },
// ];

// const DashBoardLayerEight = () => {
//     return (
//         <div className="accordion" id="accordionPanelsStayOpenExample">
//             <div className="accordion-item">
//                 <h2 className="accordion-header" id="panelsStayOpen-headingOne">
//                     <button className="accordion-button" type="button">
//                         Revenue Overview (Own Rev: ₹ 18500 | Partnership Rev: ₹0 | Franchise Rev: ₹ 0)
//                     </button>
//                 </h2>

//                 <div className="accordion-collapse collapse show">
//                     <div className="accordion-body">
//                         <div className="accordion" id="accordionExample">
//                             {statesList.map(({ id, name, revenue, refund }) => {

//                                 return (
//                                     <div className="accordion-item bg_sky" key={id}>
//                                         <h2 className="accordion-header" id={`heading_${id}`}>
//                                             <button
//                                                 className="accordion-button collapsed" // Closed by default
//                                                 type="button"
//                                                 data-bs-toggle="collapse"
//                                                 data-bs-target={`#collapse_${id}`} // Unique target
//                                                 aria-expanded="false"
//                                                 aria-controls={`collapse_${id}`}
//                                             >
//                                                 {name} (Rev: {revenue}) (Ref: {refund})
//                                             </button>
//                                         </h2>

//                                         <div
//                                             id={`collapse_${id}`}
//                                             className="accordion-collapse collapse" // Closed by default
//                                             aria-labelledby={`heading_${id}`}
//                                         >
//                                             <div className="accordion-body">
//                                                 (
//                                                 <div className='row gy-4'>
//                                                     <div className='col-xxxl-12'>
//                                                         <div className='row gy-4' style={{ padding: '15px' }}>
//                                                             <DailyReportTable
//                                                                 id={id}
//                                                                 mainHeader={mainHeader}
//                                                                 statename={name}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 )
//                                             </div>
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DashBoardLayerEight;
